/*
 * Copyright (C) 2020 Reciprocity, Inc - All Rights Reserved
 * Unauthorized use, copying, distribution, displaying, or public performance
 * of this file, via any medium, is strictly prohibited. All information
 * contained herein is proprietary and confidential and may not be shared
 * with any third party without the express written consent of Reciprocity, Inc.
 */

/*
TODO: Content of this file was mainly copeid from frontend/src/components/tooltips/utils.ts!
  It was modified a bit. When dropdownFormPresenter is no longer used (is substituted with ZenObjectsDropdown), remove the aforementoned file.
*/

import gql from 'graphql-tag';

export const OBJECTS_QUERY = gql`
  query Objects($objectType: SearchType!, $pageSize: Int, $after: String, $order: OrderBy!, $filter: JSONString) {
    objects: search(type: $objectType, first: $pageSize, after: $after, order: $order, filter: $filter) {
      pageInfo {
        endCursor
      }
      edges {
        node {
          id
          ... on SorNode {
            # TODO: Remove after filters support filtering by id
            sorCode {
              value
            }

            sorTitle {
              value
            }
          }
        }
      }
    }
  }
`;

export const GROUPS_QUERY = gql`
  query Groups($pageSize: Int, $after: String, $order: OrderBy!, $filter: JSONString) {
    objects: search(type: Group, first: $pageSize, after: $after, order: $order, filter: $filter) {
      pageInfo {
        endCursor
      }
      edges {
        node {
          ... on Group {
            id
            title {
              value
            }
            isPrivate {
              value
            }
            people {
              value(first: 1) {
                totalCount
                edges {
                  node {
                    id
                    name {
                      value
                    }
                    email {
                      value
                    }
                    userRole {
                      value
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
  }
`;

export const PEOPLE_QUERY = gql`
  query People($pageSize: Int, $after: String, $order: OrderBy!, $filter: JSONString) {
    objects: search(type: Person, first: $pageSize, after: $after, order: $order, filter: $filter) {
      pageInfo {
        endCursor
      }
      edges {
        node {
          id
          ... on Person {
            name {
              value
            }
            email {
              value
            }
            userRole {
              value
            }
          }
        }
      }
    }
  }
`;
